module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-panel"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('pre', {
    staticClass: "title"
  }, [_vm._v("-----------------------\n|       __  _ ___ ___ |\n|  /\\  (_  /   |   |  |\n| /--\\ __) \\_ _|_ _|_ |\n| ___                 |\n|  |  _   _|  _.    | |\n|  | (_) (_| (_| \\/ o |\n|                /    |\n-----------------------")]), _vm._v(" "), _c('p', [_vm._v("A super-fast ASCII title generator.")]), _vm._v(" "), _c('p', [_vm._v("Spruce up your code comments and readmes. Have fun!")]), _vm._v(" "), _c('p', [_vm._v("By "), _c('a', {
    attrs: {
      "href": "//lokeshdhakar.com"
    }
  }, [_vm._v("Lokesh Dhakar")]), _vm._v(" - "), _c('a', {
    attrs: {
      "href": "https://github.com/lokesh/ascii-today"
    }
  }, [_vm._v("Code on Github")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72761047!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoPanel.vue
// module id = 34
// module chunks = 0